import { observer } from 'mobx-react-lite';
import { FC } from 'react';

import { DotsIcon, IcBackIcon } from '@gem/icons';
import { IconButton, IconViewSizes } from '@gem/ui-kit';

import { AvatarTypes } from 'APP/components/Avatar/Avatar';
import { SpaceAvatar } from 'APP/components/Avatar/SpaceAvatar/SpaceAvatar';
import { VerifiedBadge } from 'APP/components/VerifiedBadge/VerifiedBadge';
import { Space } from 'STORE/Spaces/Space';

import { useSpacePanelHeaderPresenter } from './SpacePanelHeader.presenter';
import styles from './SpacePanelHeader.styles.m.css';

interface ISpacePanelHeaderProps {
  space: Space | null;
}

export const SpacePanelHeader: FC<ISpacePanelHeaderProps> = observer(({ space }) => {
  const presenter = useSpacePanelHeaderPresenter(space);

  return (
    <div className={styles.container}>
      <IconButton
        className={styles.button}
        Icon={IcBackIcon}
        theme="8"
        size={IconViewSizes.Big}
        iconSize={IconViewSizes.Medium}
        onClick={presenter.onClose}
      />

      {space && (
        <>
          <SpaceAvatar
            className={styles.avatar}
            space={space}
            type={AvatarTypes.Square_10}
          />

          <div className={styles.titleWrapper}>
            <h3
              className={styles.title}
              title={space.name}
            >
              {space.name}
            </h3>
            {presenter.verified && <VerifiedBadge />}
          </div>
          {presenter.canOpenProfile && (
            <IconButton
              className={styles.profile}
              Icon={DotsIcon}
              size={IconViewSizes.Big}
              onClick={presenter.onOpenProfile}
            />
          )}
        </>
      )}
    </div>
  );
});
